import { cn } from '@/lib/utils'
import React from 'react'

type Props = {
  error?: string
  id: string
  children: JSX.Element | string | JSX.Element[]
  checked?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const Checkbox = React.forwardRef<HTMLInputElement, Props>(
  ({ id, children, error, ...props }, ref) => (
    <div>
      <div className={cn('flex items-start space-x-2')}>
        <input
          className="peer mt-[3px] h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground"
          type="checkbox"
          {...props}
          ref={ref}
          id={id}
          checked={props.checked}
          onChange={props.onChange}
        />
        <label
          className={cn('text-sm text-primary', error && 'text-red-500')}
          htmlFor={id}
        >
          {children}
        </label>
      </div>
    </div>
  ),
)

Checkbox.displayName = 'Checkbox'

export default Checkbox
